import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useQuery as useGetNotificationQuery } from "@faire/web-api--source/api/retailer/notifications/get-hooks";
// Refetch notifications every 5 minutes as average session length is 15 minutes
var REFETCH_INTERVAL_MS = 1000 * 60 * 5;
export var useNotificationQuery = function() {
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    return useGetNotificationQuery({
        enabled: !!retailerToken,
        refetchInterval: REFETCH_INTERVAL_MS,
        // Forced refetches are handled by refetchInterval & specific high priority route navigations
        staleTime: Infinity
    });
};
